import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "input", "toggle"]
  static values = { open: { type: Boolean, default: false } }

  connect() {
    this.render()
  }

  open() {
    this.openValue = true
    this.render()
    this.focusInput()
  }

  close() {
    this.openValue = false
    this.render()
  }

  toggle() {
    this.openValue = !this.openValue
    this.render()
    if (this.openValue) this.focusInput()
  }

  suggest(event) {
    this.openValue = true
    this.render()

    const prompt = event.params.prompt
    if (prompt && this.hasInputTarget && this.inputTarget.value.trim() === "") {
      this.inputTarget.value = prompt
      this.inputTarget.dispatchEvent(new Event("input", { bubbles: true }))
    }

    this.focusInput()
  }

  openValueChanged() {
    this.render()
  }

  render() {
    this.element.classList.toggle("suggestion-detail--chat-open", this.openValue)
    this.element.classList.toggle("suggestion-detail--chat-closed", !this.openValue)

    if (this.hasPanelTarget) {
      this.panelTarget.hidden = !this.openValue
    }

    this.toggleTargets.forEach((toggle) => {
      toggle.setAttribute("aria-expanded", this.openValue.toString())
    })
  }

  focusInput() {
    if (!this.hasInputTarget) return

    requestAnimationFrame(() => this.inputTarget.focus())
  }
}
